import { render } from "./Facts.vue?vue&type=template&id=7f5279d5&scoped=true"
import script from "./Facts.vue?vue&type=script&lang=js"
export * from "./Facts.vue?vue&type=script&lang=js"

import "./Facts.vue?vue&type=style&index=0&id=7f5279d5&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src954499401/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f5279d5"]])

export default __exports__